export var itemGroupMixin = {
  data: () => {
    return {
      itemGroupQuery: {
        codigo: '',
        descricao: '',
        classificacao: '',
        page: 1,
        todos: null,
      },
      selectedHeaderOptions: [
        {
          text: 'CODIGO',
          value: 'CODIGO',
          align: 'start',
        },
        {
          text: 'DESCRICAO',
          value: 'DESCRICAO',
        },
        {
          text: 'CLASSIFICACAO',
          value: 'CLASSIFICACAO',
        },
        {
          text: 'Ações',
          value: 'controls',
          align: 'right',
        },
      ],
    }
  }
}
